export enum GroupLevel {
    Country = 'Country',
    Cluster = 'Cluster',
}
